import { useSelector } from 'react-redux';

import { userDestinationsSelectors as selectors } from '@anm/store/modules/userDestinations';

export const useDestinationListIsError = () => {
  const isError = useSelector(selectors.selectDestinationsListIsError);

  return isError;
};
